// extracted by mini-css-extract-plugin
export default {"container":"ChekPhoneNumberForm_container__Olka7","content":"ChekPhoneNumberForm_content__uTi61","logo":"ChekPhoneNumberForm_logo__vQ5-R","form":"ChekPhoneNumberForm_form__RJydL"};